<template>
  <div class="officialAccountStatement">
    <div class="functionalArea">
      <div class="item">
        <span class="item_title">平台</span>
        <el-select
          v-model="parameter.platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="clean"
          @change="alew"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="item_title">公众号名称</span>
        <el-input v-model="parameter.wechat_name" placeholder="请输入公众号名称" style="width:250px" />
      </div>
      <div class="item">
        <span class="item_title">公众号appId</span>
        <el-input v-model="parameter.app_id" placeholder="请输入公众号appId" style="width:250px" />
      </div>
      <div class="item">
        <span class="item_title">小说名称</span>
        <el-input v-model="parameter.novel_name" placeholder="请输入小说名称" style="width:250px" />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="timesr"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          :default-value="timeDefaultShow"
        />
      </div>
      <el-button type="primary" style=" margin-top: 7px;" @click="submit">搜索</el-button>
      <el-button type="primary" style=" margin-top: 7px;" @click="reset">重置</el-button>
      <el-button type="primary" style=" margin-top: 7px;" icon="el-icon-s-help" @click="export1">导出</el-button>
    </div>
    <div class="contentArea">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 5px;">
        <div class="mybox"><span>首充</span><span class="chong green" /></div>
        <div class="mybox"><span>副充</span><span class="chong" style="background-color:#beadff;" /></div>
        <div class="mybox"><span>总充</span><span class="chong" style="background-color: rgb(234 160 219);" /></div>
        <div class="mybox"><span>首充回本</span><span class="chong" style="background-color: #34e5dd;" /></div>
        <div class="mybox"><span>副充回本</span><span class="chong yellow" /></div>
        <div class="mybox"><span>总充回本（今日）</span><span class="chong" style="background-color:  rgb(232 118 95);" /></div>
        <div class="mybox"><span>总充回本（至今）</span><span class="chong powder" /></div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        max-height="500"
      >
        <el-table-column
          label="时间"
          prop="channel_date"
          width="120"
          fixed="left"
        />
        <el-table-column
          label="主公众号_appid"
          prop="master_appid"
          width="200"
        />
        <el-table-column
          label="公众号组_appid"
          prop="app_ids"
          width="200"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="JSON.parse(scope.row.app_ids).length > 3"
              placement="top-start"
              title="全部"
              width="200"
              trigger="hover"
              :content="JSON.parse(scope.row.app_ids).join('\n')"
            >
              <p slot="reference" style="white-space: break-spaces;">{{ transformation(scope.row.app_ids, scope.row.id) }}</p>
            </el-popover>
            <p v-else style="white-space: break-spaces;">{{ transformation(scope.row.app_ids, scope.row.id) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="公众号组"
          prop="wechat_name"
          width="120"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="JSON.parse(scope.row.wechat_name).length > 3"
              placement="top-start"
              title="全部"
              width="200"
              trigger="hover"
              :content="JSON.parse(scope.row.wechat_name).join('\n')"
            >
              <p slot="reference" style="white-space: break-spaces;">{{ transformation(scope.row.wechat_name, scope.row.id) }}</p>
            </el-popover>
            <p v-else style="white-space: break-spaces;">{{ transformation(scope.row.wechat_name, scope.row.id) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="小说名称"
          prop="novel_name"
          width="200"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="JSON.parse(scope.row.novel_name).length > 3"
              placement="top-start"
              title="全部"
              width="200"
              trigger="hover"
              :content="JSON.parse(scope.row.novel_name).join('\n')"
            >
              <p slot="reference" style="white-space: break-spaces;">{{ transformation(scope.row.novel_name, scope.row.id) }}</p>
            </el-popover>
            <p v-else style="white-space: break-spaces;">{{ transformation(scope.row.novel_name, scope.row.id) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="分成比例"
          prop="share_proportion"
          width="120"
        />
        <el-table-column
          label="消耗"
          prop="consume"
          width="120"
        >
          <template slot-scope="scope">
            <template v-if="consume.id !== scope.row.id">
              <span>{{ scope.row.consume }}</span>
              <i class="el-icon-edit" style="margin-left:10px; cursor: pointer;" @click="(consume.id = scope.row.id),(consume.value = scope.row.consume)" />
            </template>
            <el-input v-else v-model="consume.value" style="height: 25px;" @input="myInput" @change="myChange" @blur="consume = { id: null, value: null }" />
          </template>
        </el-table-column>
        <el-table-column
          label="新用户充值"
          prop="new_user_recharge"
          width="120"
        />
        <el-table-column
          label="累计充值"
          prop="total_recharge"
          width="120"
        />
        <el-table-column
          label="总消耗（不含当日）"
          prop="total_consume"
          width="200"
        />
        <el-table-column
          label="平台"
          prop="platform_name"
          width="120"
        />
        <el-table-column
          label="新用户充值（扣除佣金）"
          prop="new_user_recharge_commission"
          width="200"
        />
        <el-table-column
          label="累积充值（扣除佣金）"
          prop="total_recharge_commission"
          width="200"
        />
        <el-table-column
          label="新用户roi"
          prop="new_user_roi"
          width="120"
        />
        <el-table-column
          label="当日回收"
          prop="today_back"
          width="120"
        />
        <el-table-column
          label="付费增长率"
          prop="payment_growth_rate"
          width="120"
        />
        <el-table-column v-for="index in 60" :key="index" :label="'第'+index+'天'" width="180">
          <template scope="scope">
            <div v-if="scope.row.data" style="background-color: rgb(234 160 219); display: initial;">{{ scope.row.data[index-1].zc }}</div>
            <div v-if="scope.row.data">
              <span style="background-color: rgb(232 118 95);">{{ scope.row.data[index-1].tcb }}%</span>
              <span class="powder magLfte">{{ scope.row.data[index-1].tcbi }}%</span>
              <span class="red magLfte">{{ scope.row.data[index-1].fans }}</span>
            </div>
            <div v-if="scope.row.data">
              <span class="green magRig" style="background-color: #34e5dd;">{{ scope.row.data[index-1].scb }}%</span>
              <span class="yellow magRig">{{ scope.row.data[index-1].fcb }}%</span>
            </div>
            <div v-if="scope.row.data">
              <span class="green magRig">{{ scope.row.data[index-1].sc }}</span>
              <span class="yellow magRig" style="background-color:#beadff;">{{ scope.row.data[index-1].fc }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      :current-page="parameter.page"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { getList, modifyConsumption, exportOfficialAccountReport } from '@/api/report/officialAccountStatement.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getchannelplatform } from '@/api/report/wechatUsers.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      total: null,
      parameter: {
        page: 1, // 页数
        page_size: 10, // 每页条数
        app_id: null, // 公众号appId
        wechat_name: null, // 公众号名称
        platform_id: null, // 平台
        novel_name: null, // 小说
        start_time: null, // 开始时间
        end_time: null // 结束时间
      },
      tableData: [], // 列表数据
      loading: false, // 是否加载中
      pickerOptions: {
        disabledDate(v) {
          return (
            v.getTime() >
            new Date().getTime() - (86400000 - 24 * 60 * 60 * 1000)
          )
        }
      },
      timeDefaultShow: '',
      platformSelectList: [],
      timesr: '',
      consume: {
        id: null,
        value: null
      }
    }
  },
  created() {
    this.myGetList()
    this.myGetchannelplatform()
  },

  methods: {
    async myGetList() {
      this.loading = true
      const data = await getList(this.parameter)
      this.loading = false
      this.total = data.data.count
      this.tableData = data.data.list
    },

    // 分页
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.myGetList()
    },
    fetchCurrentPage(e) {
      this.parameter.page = e
      this.myGetList()
    },

    transformation(strings, id) {
      const das = JSON.parse(strings)
      const das1 = das.length > 3 ? das.slice(0, 3) : das
      das.length > 3 && das1.push('...')
      return das1.join('\n')
    },

    async myGetchannelplatform() {
      const data = await getchannelplatform()
      this.platformSelectList = data.data.list
    },

    clean() {
      this.parameter.platform_id = null
    },

    alew() {

    },

    submit() {
      if (this.timesr.length > 1) {
        this.parameter.start_time = this.timesr[0]
        this.parameter.end_time = this.timesr[1]
      }
      this.parameter.page = 1
      this.myGetList()
    },

    reset() {
      this.parameter = {
        page: 1, // 页数
        page_size: 10, // 每页条数
        app_id: null, // 公众号appId
        wechat_name: null, // 公众号名称
        platform_id: null, // 平台
        novel_name: null, // 小说
        start_time: null, // 开始时间
        end_time: null // 结束时间
      }
      this.timesr = ''
      this.myGetList()
    },

    myInput(value) {
      this.consume.value = this.checkNum(value)
    },

    async myChange() {
      await modifyConsumption({ id: this.consume.id, consume: Number(this.consume.value).toFixed(2) })
      await this.myGetList()
      this.consume = { id: null, value: null }
    },

    aa() {
      console.log('aa')
    },

    checkNum(val) {
      const zhi = val.charAt(0)
      // 转化为数字形式--包含小数，负数，e
      // 先把非数字的都替换掉，除了数字和.,e,-
      val = val.replace(/[^\d.e-]/g, '')
      // 必须保证第一个为数字而不是.
      val = val.replace(/^\./g, '')
      // 保证只有出现一个.而没有多个.
      val = val.replace(/\.{2,}/g, '.')
      // 保证.只出现一次，而不能出现两次以上
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      // 如果第一位是负号，则允许添加
      if (zhi === '-') {
        // val = '-' + val
      }
      // 数字千分位逗号分隔
      // var str = val.toString();
      // var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      // return str.replace(reg,"$1,");
      return val
    },

    // 导出
    export1() {
      this.$confirm('是否确定导出报表', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await exportOfficialAccountReport({
          wechat_name: this.parameter.wechat_name,
          platform_id: this.parameter.platform_id,
          novel_name: this.parameter.novel_name,
          start_time: this.timesr && this.timesr[0],
          end_time: this.timesr && this.timesr[1]
        })
        this.myGetList()
        this.$message({
          type: 'success',
          message: '在后台中导出成功'
        })
      }).catch(() => {
      })
    }

  }
}
</script>

<style scoped lang="less">
.officialAccountStatement{
  width: 90%;
  margin: 0 auto;
  margin-top: 50px;
   .functionalArea{
      margin-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
   }
   .contentArea{

   }
}

.item{
  margin-top: 7px;
  margin-right: 15px;
  .item_title{
    display: inline-block;
    margin-right: 10px;
  }
}
.el-icon-edit:hover{
  font-weight: bold;
}

/deep/ .cell input{
  height: 25px;
}

/deep/ .el-popover{
  white-space: break-spaces !important;
}

/deep/ .el-table {
   border: 1px solid #ccc;
}

    .powder {
      background: rgb(248, 216, 216);
    }
    .green {
      background: rgb(52, 229, 54);
    }
    .yellow {
      background: rgb(255, 247, 173);
    }
    .blue {
      background: rgb(158, 211, 252);
    }
    .red {
      background: #ffa500;
    }

    .magRig {
      margin-right: 10px;
    }
    .magLfte {
      margin-left: 10px;
    }
    .chong{
          display: inline-block;
          width: 13px;
          height: 86%;
          margin-left: 6px;
    }
    .mybox{
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
</style>
